export default __webpack_public_path__ + "static/media/VerifyOTP.99169bd1.svg";